<template>
  <div class="container">
    <div class="row" style="margin-top: 30px">
      <div class="col-md-12">
        <div class="tabs tabs-bottom tabs-center tabs-simple">
          <ul class="nav nav-tabs">
            <li>
              <a href="#tabsNavigationLoginPendaftaran" data-toggle="tab">Login</a>
            </li>
            <li class="active">
              <a href="#tabsNavigationPembayaran" data-toggle="tab">Simulasi Pembayaran</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="col-md-12 tab-pane" id="tabsNavigationLoginPendaftaran">
              <div class="col-md-6 col-md-offset-3">
                <div class="featured-box featured-box-primary align-left mt-xlg">
                  <div class="box-content">
                    <h4 class="heading-primary align-center text-uppercase mb-md">Login</h4>
                    <div class="alert alert-danger" v-show="$store.state.auth.isError">
                      <p>Login gagal, pastikan ID Pendaftaran dan PIN Pendaftaran benar. Atau pastikan Tanggal Pendaftaran sesuai dengan Jalur yang anda pilih.</p>
                    </div>
                    <form class="form-horizontal" onsubmit="return false">
                      <div :class="{'form-group': true, 'has-error': errors.has('username') }">
                        <label style="margin-left: 15px">Username</label>
                        <div class="col-sm-12">
                          <input
                            type="text"
                            name="username"
                            placeholder="KODE (8 digit)"
                            class="form-control"
                            v-model="username"
                            v-validate="'required'"
                            @keyup.enter="login"
                          >
                          <span v-show="errors.has('username')" class="help">{{ errors.first('username') }}</span>
                        </div>
                      </div>
                      <div :class="{'form-group': true, 'has-error': errors.has('password') }">
                        <label style="margin-left: 15px">Password</label>
                        <div class="col-sm-12">
                          <input
                            :type="typePass"
                            name="password"
                            placeholder="PIN (16 digit)"
                            class="form-control"
                            v-model="password"
                            v-validate="'required'"
                            @keyup.enter="login"
                          >
                          <span v-show="errors.has('password')" class="help">{{ errors.first('password') }}</span>
                          <div style="margin-top: 10px"><input type="checkbox" v-model="showPass">    Show Password</div>
                        </div>
                      </div>
                      <div class="form-group" style="margin-right: 5px">
                        <button
                          class="btn btn-primary pull-right"
                          style="min-width: 80px"
                          :disabled="$store.state.auth.isLoading"
                          @click="login">
                          Masuk
                        </button>
                      </div>
                    </form>
                    <center>
                      <pulse-loader style="margin: 15px" :loading="$store.state.auth.isLoading" color="#696969" size="10px"></pulse-loader>
                    </center>
                  </div>
                </div>
                <div class="alert alert-success">
                  ID Pendaftaran dan PIN didapatkan dari slip yang didapatkan setelah melakukan pembayaran di bank.
                </div>
                <div class="alert alert-light" >
                  <div class="align-center">
                    <p>Panduan Pembayaran</p>
                    <a @click="toTutorLivin" style="cursor: pointer"><img height="70" src="../assets/img/logo_livin.png" class="rounded-circle"></a>
                    <a @click="toTutorLinkAja" style="cursor: pointer"><img height="70" src="../assets/img/logo_linkaja.png" class="rounded-circle"></a>
                    <a @click="toTutorAtmMandiri" style="cursor: pointer"><img height="100" src="../assets/img/logo_mandiri_atm.png" class="rounded-circle"></a>
                    <!-- <img height="50" src="../assets/img/logo_bni.png" class="rounded-circle"> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 tab-pane active" id="tabsNavigationPembayaran">
              <div class="col-md-6 col-sm-offset-3">
                <div class="featured-box featured-box-primary align-left mt-xlg">
                  <div class="box-content">
                    <h4 class="heading-primary align-center text-uppercase mb-md">Simulasi Pembayaran</h4>
                    <div class="alert alert-danger" v-show="idProdi && !options.jalur">
                      <p> {{`Maaf, saat ini jalur untuk jenjang tersebut belum dibuka`}} </p>
                    </div>
                    <form class="form-horizontal">
                      <div class="form-group">
                        <label style="margin-left: 15px">Jenjang</label>
                        <div class="col-md-12">
                          <select
                            name="jenjang"
                            id="jenjang"
                            class="form-control col-md-3"
                            v-model="kodeJenjang"
                            v-validate="'required'"
                            @change="onChange">
                            <option value="null" hidden>Pilih Jenjang</option>
                            <option v-for="item in jenjang" :key="item.id" :value="item.id_jenjang">{{ item.nama_jenjang }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label style="margin-left: 15px">Fakultas</label>
                        <div class="col-md-12">
                          <select
                            name="fakultas"
                            id="fakultas"
                            class="form-control col-md-3"
                            v-model="idFakultas"
                            v-validate="'required'"
                            @change="onChangeFakultas">
                            <option value="null" hidden>Pilih Fakultas</option>
                            <option v-for="item in options.fakultas" :key="item.id" :value="item.id_fakultas">{{ item.fakultas.nama_fakultas }}</option>
                          </select>
                        </div>
                      </div>
                      <pulse-loader style="margin: 15px" :loading="loading.fakultas" color="#696969" size="10px"></pulse-loader>
                      <div class="form-group">
                        <label style="margin-left: 15px">Program Studi</label>
                        <div class="col-md-12">
                          <select
                            name="prodi"
                            id="prodi"
                            class="form-control col-md-3"
                            v-model="idProdi"
                            v-validate="'required'"
                            @change="onChangeProdi">
                            <option value="null" hidden>Pilih Program Studi</option>
                            <option v-for="item in options.programStudi" :key="item.id" :value="item.id_prodi">{{ item.nama_prodi }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label style="margin-left: 15px">Jalur Pendaftaran</label>
                        <div class="col-md-12">
                          <select
                            name="jalur"
                            id="jalur"
                            class="form-control col-md-3"
                            v-model="kodeBayar"
                            v-validate="'required'">
                            <option value="null" hidden>Pilih Jalur</option>
                            <option v-for="item in options.jalur" :key="item.id" :value="item.kode_bayar">{{ item.jalur_masuk }} Gelombang {{ item.nama }}</option>
                          </select>
                        </div>
                      </div>
                      <pulse-loader style="margin: 15px" :loading="loading.jalur" color="#696969" size="10px"></pulse-loader>
                      <div class="form-group">
                        <label style="margin-left: 15px">Tanggal Lahir</label>
                        <div class="col-sm-12">
                          <datetimepicker format="DD-MM-YYYY" @update-date="updateDate"></datetimepicker>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="col-sm-offset-6 col-sm-6">
                          <a class="btn btn-primary pull-right" @click="showKode">Kode Pembayaran</a>
                        </div>
                      </div>
                    </form>
                    <div class="alert alert-light" >
                      <div class="align-center">
                        <p>Panduan Pembayaran</p>
                        <a @click="toTutorLivin" style="cursor: pointer"><img height="70" src="../assets/img/logo_livin.png" class="rounded-circle"></a>
                        <a @click="toTutorLinkAja" style="cursor: pointer"><img height="70" src="../assets/img/logo_linkaja.png" class="rounded-circle"></a>
                        <a @click="toTutorAtmMandiri" style="cursor: pointer"><img height="100" src="../assets/img/logo_mandiri_atm.png" class="rounded-circle"></a>
                        <!-- <img height="50" src="../assets/img/logo_bni.png" class="rounded-circle"> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-offset-3">
                <center>
                  <div class="alert alert-success" v-show="showKodePembayaran">
                    <p>Calon peserta PMB Mandiri S1/S2 membayar biaya seleksi di Bank Mandiri dengan menyebutkan kode berikut kepada petugas Bank.</p><br>
                    <h2>{{ kode }}</h2>
                    <p>Setelah membayar, calon peserta akan mendapatkan bukti pembayaran dari bank yang mencantumkan ID (username) dan PIN (password) yang akan digunakan untuk login ke sistem PMB.</p>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker'
import Options from '@/helper/options'

export default {
  data () {
    return {
      username: null,
      password: null,
      kodeJenjang: null,
      kodeBayar: null,
      idFakultas: null,
      idProdi: null,
      birthdate: null,
      kode: null,
      showKodePembayaran: false,
      showPass: false,
      options: {
        fakultas: null,
        programStudi: null,
        jalur: null
      },
      loading: {
        fakultas: false,
        jalur: false
      }
    }
  },
  created () {
    this.$store.dispatch('getAllJenjang')
    this.$store.dispatch('getAllPenawaranJalur')
    this.$store.dispatch('getAllFakultas')
    this.$store.dispatch('getAllProgramStudi')
  },
  components: {
    'datetimepicker': DateTimePicker
  },
  computed: {
    typePass () {
      if (this.showPass) {
        return 'text'
      } else {
        return 'password'
      }
    },
    year () {
      let today = new Date()
      return today.getFullYear().toString()
    },
    jenjang () {
      return this.$store.getters.allJenjang
    },
    programStudi () {
      return this.$store.getters.getAllProgramStudiData.all
    }
  },
  methods: {
    updateDate (date) {
      this.showKodePembayaran = false
      this.birthdate = date
    },
    showKode () {
      let birthdate = this.birthdate.replace(/-/g, '')
      if (this.kodeBayar != null) {
        this.kode = `${this.kodeBayar}${birthdate}`
      } else this.kode = `Mohon pilih jalur terlebih dahulu`
      this.showKodePembayaran = true
    },
    async onChange () {
      this.showKodePembayaran = false
      this.loading.fakultas = true
      try {
        this.options.fakultas = await Options.getOptionsFakultasJenjang(this.kodeJenjang)
      } catch (e) {
        console.log(e)
      }
      this.loading.fakultas = false
      this.options.jalur = null
      this.options.programStudi = null
      this.idFakultas = null
      this.idProdi = null
      this.kodeBayar = null
    },
    onChangeFakultas () {
      this.options.programStudi = this.programStudi.filter(prodi => prodi.id_fakultas === this.idFakultas && prodi.id_jenjang === this.kodeJenjang)
      this.idProdi = null
      this.kodeBayar = null
      this.options.jalur = null
    },
    async onChangeProdi () {
      this.loading.jalur = true
      try {
        this.options.jalur = await Options.getOptionsPenawaranJalurProdi(this.idProdi)
      } catch (e) {
        console.log(e)
      }
      this.loading.jalur = false
      this.kodeBayar = null
    },
    login () {
      this.$validator.validateAll({
        username: this.username,
        password: this.password
      }).then((result) => {
        if (result) {
          this.$store.dispatch('login', { username: this.username, password: this.password })
        }
      })
    },
     toTutorLivin () {
      window.open("https://drive.google.com/file/d/1uZI2nJTitcVFkzpI7LdCXF4ceV4Vj2fh/view?usp=sharing", "_blank")
    },
    toTutorLinkAja () {
      window.open("https://drive.google.com/file/d/1DKMuklTZowvzvVyTTvZT24FHrfjquiuP/view?usp=sharing", "_blank")
    },
    toTutorAtmMandiri () {
      window.open("https://drive.google.com/file/d/11O8D6JzheCiCgQ3yaQ-VJd893USnGgOI/view?usp=sharing", "_blank")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/LoginSimulasi.vue